/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type AgentCrashBuild = {
  arch?: string | undefined;
  /**
   * speakeasyd or speakeasy-ui.
   */
  binary: string;
  /**
   * Release channel.
   */
  channel?: string | undefined;
  os?: string | undefined;
  /**
   * OS release, e.g. 15.4 on macOS or the kernel release on Linux.
   */
  osVersion?: string | undefined;
  version: string;
};

/** @internal */
export type AgentCrashBuild$Outbound = {
  arch?: string | undefined;
  binary: string;
  channel?: string | undefined;
  os?: string | undefined;
  os_version?: string | undefined;
  version: string;
};

/** @internal */
export const AgentCrashBuild$outboundSchema: z.ZodMiniType<
  AgentCrashBuild$Outbound,
  AgentCrashBuild
> = z.pipe(
  z.object({
    arch: z.optional(z.string()),
    binary: z.string(),
    channel: z.optional(z.string()),
    os: z.optional(z.string()),
    osVersion: z.optional(z.string()),
    version: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      osVersion: "os_version",
    });
  }),
);

export function agentCrashBuildToJSON(
  agentCrashBuild: AgentCrashBuild,
): string {
  return JSON.stringify(AgentCrashBuild$outboundSchema.parse(agentCrashBuild));
}
